import React, { useContext, useEffect, useState } from 'react';
import { ListGroup, Button } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ConfigContext } from '../../../../contexts/ConfigContext';
import { useModuloControle } from '../../../../contexts/ModuloControleContext';
import { HEADER_BACK_COLOR, MODULOATUAL } from '../../../../store/actions';
import { Tooltip } from '@mui/material';

const NavLeft = () => {
  const configContext = useContext(ConfigContext);
  const { dispatch } = configContext;
  const { isDemonstracao, isPlanoResgate, ativouTesteGestao, duplicidadeCadastro } = useModuloControle();

  
  const storageRaw = sessionStorage.getItem('ddesp');
  const storage = JSON.parse(atob(storageRaw));
  const history = useHistory();
  const location = useLocation();
  const [exibeAssinar, setExibeAssinar] = useState({ gestao: false, resgate: false });
  const [bloqueioNavBar, setBloqueioNavBar] = useState(true);
  const [moduloAtual, setModuloAtual] = useState(1);
  const strgRsg = storage[39]['10'] === undefined ? true : storage[39]['10'];

  if(strgRsg === false) {
    localStorage.setItem('moduloAtual', String(0));
    history.push('/dashboard');
  }
  // useEffect(() => {
  //   if (window.location.href.indexOf('inicio') > -1) {
  //     localStorage.setItem('moduloAtual', 1);
  //     setBloqueioNavBar(true);
  //   } else {
  //     setBloqueioNavBar(false);
  //   }
  //   setTimeout(() => {
  //     const modStorage = localStorage.getItem('moduloAtual');
  //     if (modStorage !== null) {
  //       if (modStorage !== moduloAtual) {
  //         setModuloAtual(Number(modStorage));

  //         dispatch({ type: MODULOATUAL, moduloAtual: Number(modStorage) });
  //         let link_ = window.location.href.replace(ENDERECO_API, '');
  //         if (Number(modStorage) === 0) {
  //           // history.push('/dashboard');
  //           if (!link_.includes('/planos')) {
  //             //history.push('/dashboard');
  //           }
  //         } else if (Number(modStorage) === 1) {

  //           if (!link_.includes('/resgate/resgatarxml')) {
  //             //history.push('/resgate/resgatarxml');
  //           }
  //         }
  //       }
  //     }
  //   }, 200);

  //   //
  // }, []);

  // useEffect(() => {
  //     if (isDemonstracao) {
  //       setExibeAssinar({ gestao: true, resgate: true });
  //     } else if (isPlanoResgate) {
  //       if (ativouTesteGestao) {
  //         setExibeAssinar({ gestao: true, resgate: false });
  //       } else {
  //         setExibeAssinar({ gestao: false, resgate: false });
  //       }
  //     }
  // }, [configContext.state.moduloAtual]);

  useEffect(() => {
    const isInicio = location.pathname.includes('inicio');
    setBloqueioNavBar(isInicio);
  }, [location.pathname]);

  useEffect(() => {
    dispatch({ type: MODULOATUAL, moduloAtual: 1 });
    dispatch({
      type: HEADER_BACK_COLOR,
      headerBackColor: 'header-info',
    });
  }, []);

  useEffect(() => {
    if (location.pathname.includes('liberarAcesso')) {
      setExibeAssinar({ gestao: false, resgate: false });
    }
    if (isDemonstracao) {
      setExibeAssinar({ gestao: true, resgate: true });
    } else if (isPlanoResgate && ativouTesteGestao) {
      setExibeAssinar({ gestao: true, resgate: false });
    } else {
      setExibeAssinar({ gestao: false, resgate: false });
    }
  }, [isDemonstracao, isPlanoResgate, ativouTesteGestao, location.pathname]);

  const handleModuloAtual = (modulo) => {
    localStorage.setItem('moduloAtual', modulo);
    setModuloAtual(modulo);
    dispatch({ type: MODULOATUAL, moduloAtual: modulo });
    dispatch({ type: HEADER_BACK_COLOR, headerBackColor: modulo === 0 ? 'header-blue' : 'header-info' });

    if (modulo === 0) {
      history.push('/dashboard');
    } 
  };
  return (
    <React.Fragment>
      {bloqueioNavBar === false && (
        <ListGroup
          as='ul'
          bsPrefix=' '
          className='navbar-nav mr-auto ml-5 align-self-md-end'
        >
          <ListGroup.Item
            as='li'
            bsPrefix=' '
            className={`rounded-top nav-item pt-1 ${moduloAtual === 0 ? 'bg-base border-top border-success' : ''} pointer`}
            style={{ lineHeight: '42px' }}
            onClick={() => handleModuloAtual(0)}
          >
            <Link
              to={`#`}
              className={`text-decoration-none mr-3 `}
              onClick={() => handleModuloAtual(0)}
            >
              {/* <i className='mdi mdi-file-chart-check-outline ' /> */}
              <span className={`ml-1 f-1 $`}>Gestão</span>
            </Link>
          </ListGroup.Item>
          <ListGroup.Item
            as='li'
            bsPrefix=' '
            className={`pointer rounded-top  nav-item ml-3 pt-1 bg-base border-top border-success text-c-blue`}
            style={{ lineHeight: '42px' }}
            onClick={() => handleModuloAtual(1)}
          >

            <Link
              to='#'
              className={`text-decoration-none`}
            >
              {/* <i className='feather icon-layout ' /> */}
              <span className={`ml-1 f-14  text-c-blue`}>Resgate XML</span>

              {exibeAssinar.resgate === true && (
                <Tooltip title='Planos Resgate XML'>
                  <Button
                    variant='success'
                    className='rounded ml-2 p-1 px-2 f-12'
                    onClick={() => {
                      history.push('/resgate/planos');
                    }}
                  >
                    Assinar
                  </Button>
                </Tooltip>
              )}
            </Link>

          </ListGroup.Item>
        </ListGroup>
      )}
    </React.Fragment>
  );
};

export default NavLeft;
